import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

export const QuickViewArticle = lazy(
  () =>
    import('./QuickViewArticle.eager').then(mod => ({
      default: mod.QuickViewArticle,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
    isSsrAndNeedsHydration: true,
  },
);
